import {
  Box,
  Paper,
  Stack,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { Suspense } from "react";
import { Outlet } from "react-router-dom";
import { BackgroundGradientAnimation } from "./BackgroundGradientAnimation";

import { MenuRounded, NotificationAddRounded } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Credit, Profile } from "components";

export default function AuthLayout() {
  const {
    userInfo: { firstname, lastname, cellphone },
  } = useSelector((state) => state.auth);
  return (
    <Suspense>
      <Box overflow="hidden">
        <BackgroundGradientAnimation />
        <Box height={100} p={1}>
          <Paper
            sx={{
              borderRadius: 2,
              height: "100%",
              bgcolor: "action.hover",
              backdropFilter: "blur(6px)",
              WebkitBackdropFilter: "blur(6px)",
            }}
          >
            <Stack
              p={1}
              height="100%"
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center" columnGap={1}>
                <IconButton size="medium">
                  <MenuRounded />
                </IconButton>
                <Divider sx={{ height: 24 }} orientation="vertical" />
                <img
                  height={100}
                  width={100}
                  style={{ objectFit: "contain" }}
                  src="logo.svg"
                />
                {/* <Stack>
                  <Typography
                    color="primary"
                    variant="subtitle1"
                    sx={{ textShadow: "0px 1px 3px #4285f4a3" }}
                  >
                    Dordent
                  </Typography>
                  <Typography
                    fontSize={10}
                    variant="subtitle2"
                    color="text.secondary"
                  >
                    GoodBye Paper, Hello Dordent
                  </Typography>
                </Stack> */}
              </Stack>
              <Stack direction="row-reverse" alignItems="center" columnGap={1}>
                <Profile />
                <IconButton>
                  <NotificationAddRounded fontSize="small" />
                </IconButton>
                <Credit />
              </Stack>
            </Stack>
          </Paper>
        </Box>
        <Stack minHeight="calc(100vh - 100px)">
          <Outlet />
        </Stack>
      </Box>
    </Suspense>
  );
}
